var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 26C6.53043 26 7.03914 25.7893 7.41421 25.4142C7.78929 25.0391 8 24.5304 8 24C8 23.4696 7.78929 22.9609 7.41421 22.5858C7.03914 22.2107 6.53043 22 6 22C5.46957 22 4.96086 22.2107 4.58579 22.5858C4.21071 22.9609 4 23.4696 4 24C4 24.5304 4.21071 25.0391 4.58579 25.4142C4.96086 25.7893 5.46957 26 6 26V26Z",
    stroke: "#DE6161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18.5304 12 19.0391 11.7893 19.4142 11.4142C19.7893 11.0391 20 10.5304 20 10C20 9.46957 19.7893 8.96086 19.4142 8.58579C19.0391 8.21071 18.5304 8 18 8C17.4696 8 16.9609 8.21071 16.5858 8.58579C16.2107 8.96086 16 9.46957 16 10C16 10.5304 16.2107 11.0391 16.5858 11.4142C16.9609 11.7893 17.4696 12 18 12V12Z",
    stroke: "#DE6161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H16.5C16.9596 24 17.4148 23.9095 17.8394 23.7336C18.264 23.5577 18.6499 23.2999 18.9749 22.9749C19.2999 22.6499 19.5577 22.264 19.7336 21.8394C19.9095 21.4148 20 20.9596 20 20.5C20 20.0404 19.9095 19.5852 19.7336 19.1606C19.5577 18.736 19.2999 18.3501 18.9749 18.0251C18.6499 17.7001 18.264 17.4423 17.8394 17.2664C17.4148 17.0905 16.9596 17 16.5 17H8.5C7.57174 17 6.6815 16.6313 6.02513 15.9749C5.36875 15.3185 5 14.4283 5 13.5C5 12.5717 5.36875 11.6815 6.02513 11.0251C6.6815 10.3687 7.57174 10 8.5 10H12",
    stroke: "#DE6161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 21,
    cy: 12,
    r: 12,
    fill: "#DE6161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteRed);
export default __webpack_public_path__ + "static/media/routeRed.680722d6ad4fbf7f5d17fb01e22dff2b.svg";
export { ForwardRef as ReactComponent };